var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReduceDarkSpots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.852,
    height: 82.064,
    viewBox: "0 0 74.852 82.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19694.25 19287.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.293,48.125c-.052.858-1.215,1.486-2.6,1.4s-2.46-.848-2.408-1.707,1.215-1.485,2.6-1.4,2.459.848,2.407,1.706",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.744,51a1.283,1.283,0,1,1-1.156-1.63A1.43,1.43,0,0,1,203.744,51",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.833,51.128a1.283,1.283,0,1,1-1.156-1.63,1.43,1.43,0,0,1,1.156,1.63",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,46.7a1.283,1.283,0,1,1-1.157-1.63A1.431,1.431,0,0,1,206,46.7",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.979,53.9a1.547,1.547,0,1,1-1.45-1.638,1.547,1.547,0,0,1,1.45,1.638",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.962,54.053a1.547,1.547,0,1,1-1.45-1.638,1.547,1.547,0,0,1,1.45,1.638",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.555,50.151a2.044,2.044,0,1,1-1.916-2.165,2.044,2.044,0,0,1,1.916,2.165",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.71,47.05c-.048.782-1.322,1.341-2.847,1.248s-2.723-.8-2.675-1.584,1.322-1.341,2.847-1.248,2.723.8,2.675,1.584",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.814,54.762a1.052,1.052,0,1,1-.987-1.114,1.053,1.053,0,0,1,.987,1.114",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.328,50.655a1.052,1.052,0,1,1-.987-1.114,1.053,1.053,0,0,1,.987,1.114",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.272,55.542a1.052,1.052,0,1,1-.987-1.114,1.053,1.053,0,0,1,.987,1.114",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.133,51.052c-.1.446-.439.544-1.743,1.45a4.777,4.777,0,0,1-4.9,0c-1.3-.906-1.639-1-1.743-1.45",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,37.4a3.321,3.321,0,0,1,4.088.022A7.972,7.972,0,0,0,171.2,39.16a8.338,8.338,0,0,0,2.682.141,19.655,19.655,0,0,0,3.528-.847c.833-.234,1.533-.434,2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.995,40.653a3.19,3.19,0,0,1,2.507-1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.99,37.4a3.322,3.322,0,0,0-4.089.022,7.966,7.966,0,0,1-3.406,1.742,8.333,8.333,0,0,1-2.681.141,19.654,19.654,0,0,1-3.529-.847c-.833-.234-1.532-.434-2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,38.959a3.19,3.19,0,0,1,2.507,1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.692,19.283c.2,6.293-.736,30.857.679,36.191,2.482,9.324,13.7,18.48,20.754,23.456a9.984,9.984,0,0,0,11.674,0c2.172-1.53,4.737-3.458,7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.96,33.683c-.2,6.293.736,16.457-.679,21.791-2.482,9.324-13.7,18.48-20.754,23.456a9.987,9.987,0,0,1-11.674,0c-2.172-1.53-4.737-3.458-7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.363,29.741a8.669,8.669,0,0,0-5.187-2.767,28.444,28.444,0,0,0-8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.429,29.7a8.669,8.669,0,0,1,5.187-2.767,28.444,28.444,0,0,1,8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,5.618A165.332,165.332,0,0,1,199.426,16.48c10.5,9.683,18.069,23.972,24.264,41.646",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 12.251,
    x2: 23.059,
    transform: "translate(-19686.309 -19281.293)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.228,
    x2: 8.049,
    transform: "translate(-19659.189 -19285.936)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.073,
    x2: 7.662,
    transform: "translate(-19646.533 -19275.781)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.283,
    x2: 3.201,
    transform: "translate(-19631.771 -19255.77)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.812,
    x2: 4.518,
    transform: "translate(-19635.719 -19262.564)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.718,
    x2: 1.792,
    transform: "translate(-19627.953 -19249.236)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.877,
    x2: 2.188,
    transform: "translate(-19625.926 -19242.734)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.505,
    x2: 1.26,
    transform: "translate(-19623.215 -19236.463)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.255,
    x2: 5.624,
    transform: "translate(-19640.25 -19269.58)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.265,
    x2: 8.143,
    transform: "translate(-19651.373 -19281.619)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.124,65.3a1.357,1.357,0,0,1-.33-.064c.028-.04.042-.062.042-.062l-.2,0c-1.614-.708-2.965-4.189-3.942-4.565a7.888,7.888,0,0,0-2.32.392c-.392.114-1.8-.621-2.14-.441-.663.347-1.144,1.487-1.618,2.565a5.858,5.858,0,0,1-1.824,2.217h-.016l.006.007c-.1.071.15.174.15.174.827,1.014,2.182,3.284,6,3.166,3.239-.1,5.35-2.754,5.806-3.384Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.572,25.125c-1.136,3.689-6.322,7.343-6.322,14.176S153.8,48,157.324,48",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.817,43.435c-.572,3.063-1.9,3.065-3.278,3.065a1.5,1.5,0,0,0,0,3c2.414,0,3.976-.8,4.97-2.221q-.83-1.958-1.692-3.844",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.492,30.983V15.563l1.657-1.078,20.816-11.06",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceDarkSpots);
export default __webpack_public_path__ + "static/media/reduce-dark-spots.9cc059e2.svg";
export { ForwardRef as ReactComponent };